module.exports = __webpack_public_path__ + "va.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/va.svg
// module id = 873
// module chunks = 0